import { Button, colors, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';
import { CartItem } from 'components/proposal-v2/ProposalPlans';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';

export const CartItemsListStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6rem;
`;

export const CartItemRowStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 3.2rem;

  ${breakpointsMQ4.lg.down} {
    flex-direction: column-reverse;
    gap: 2rem;
  }
`;

export const AlternativePlansLabelStyled = styled.p`
  ${typography.bold[24]};
  color: ${colors.neutral[700]};
  display: flex;
  margin: 0 auto 0 48%;

  ${breakpointsMQ4.lg.down} {
    margin: 0 auto;
  }
`;

export const RemoveButtonStyled = styled(Button)`
  max-width: 12rem;
  min-width: unset;

  ${breakpointsMQ4.lg.down} {
    max-width: unset;
    width: 50%;
  }
  ${breakpointsMQ4.md.down} {
    max-width: unset;
    width: 100%;
  }
`;

export const CartItemStyled = styled(CartItem)`
  ${breakpointsMQ4.lg.down} {
    width: 100%;
  }
`;

export const CartItemsWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
`;
